import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';
import { FtpServerLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FtpServerLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                port: '*',
                enableSsl: '*',
                enableServerCertificateValidation: '*',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class FtpServerLinkedServiceAdapter extends LinkedServiceAdapter<FtpServerLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => FtpServerLinkedService {
        return FtpServerLinkedService;
    }

    protected model(): IModel {
        return FtpServerLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: FtpServerLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.FtpServerLinkedService;
        properties.type = Metamodel.modelFor(FtpServerLinkedService).name;

        const password: string | Model.SecretBase = (linkedService.authenticationType === 'Basic')
            ? parameterizablePasswordOrAKVtoSecretBase(linkedService, FtpServerLinkedService.PASSWORD, this.context)
            : undefined;
        properties.typeProperties = {
            host: this.valueToResource(linkedService, FtpServerLinkedService.HOST),
            port: this.valueToResource(linkedService, FtpServerLinkedService.PORT),
            enableSsl: linkedService.enableSsl,
            enableServerCertificateValidation: linkedService.enableSsl ? linkedService.enableServerCertificateValidation : false,
            authenticationType: linkedService.authenticationType,
            userName: linkedService.authenticationType === 'Basic' ? this.valueToResource(linkedService, FtpServerLinkedService.USER_NAME) : undefined,
            password
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: FtpServerLinkedService): Promise<FtpServerLinkedService> {
        const properties = linkedServiceResource.properties as Model.FtpServerLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.FtpServerLinkedServiceTypeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, FtpServerLinkedService.HOST, typeProperties.host);
        ValueAdapter.toModel(linkedService, FtpServerLinkedService.PORT, typeProperties.port);
        linkedService.enableSsl = typeProperties.enableSsl;
        linkedService.enableServerCertificateValidation = typeProperties.enableServerCertificateValidation;
        linkedService.authenticationType = typeProperties.authenticationType;
        ValueAdapter.toModel(linkedService, FtpServerLinkedService.USER_NAME, typeProperties.userName);
        parameterizableSecretBaseToModel(linkedService, FtpServerLinkedService.PASSWORD, typeProperties.password, this.context, linkedService.authenticationType === 'Basic');

        return linkedService;
    }
}
